/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Merge_ReasonInputs */

const cs_client_merge_reason = /** @type {(inputs: Client_Merge_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Důvod`)
};

const en_client_merge_reason = /** @type {(inputs: Client_Merge_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason`)
};

/**
* | output |
* | --- |
* | "Reason" |
*
* @param {Client_Merge_ReasonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_merge_reason = /** @type {((inputs?: Client_Merge_ReasonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Merge_ReasonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_merge_reason(inputs)
	return cs_client_merge_reason(inputs)
});